/** @deprecated use EventStatus */
export enum PersonEventStatus {
  Going = 'Are Going',
  CheckedIn = 'Checked In',
  CheckedOut = 'Checked Out',
  Interested = 'Interested',
  NotGoing = 'Not Going',
}
